import DialogActions from '@material-ui/core/DialogActions';

/** @deprecated  Exporting the DialogActions component from the material-ui library. */
export default DialogActions;
